import Pqp from "../../3x1010/Pqp.js";
import Vengine from "../vengine/Vengine.js";
export default class Char {
  constructor(dir, url, box0, box1) {
    this.dir = dir;
    this.url = url;
    this.box0 = box0;
    this.box1 = box1;

  }

  init() {

    jQuery(".js-main").css("background-image", "url('" + this.getDir() + "background.jpg')")
    jQuery(".js-interface img").attr("src", this.getDir() + "interface.png");
    jQuery(".js-title img").attr("src", this.getDir() + "title.png");
    jQuery(".js-placeholder").attr("src", this.getDir() + "placeholder.png");
    //this.loadConfig();
    this.initVengine();
    this.initBoxes();
  }

  getDir() {
    return this.dir + "/";
  }


  initVengine() {
    let vengine = new Vengine(jQuery(".js-vengine"), this.getDir(), this.url);
    vengine.init();
  }

  initBoxes() {
    for (let x = 0; x < 2; x++) {
      let box = jQuery(".js-box-" + x);
      jQuery("img", box).attr("src", this.getDir() + "box" + x + "/" + this.getIdle(x));
      if (!Pqp.isMobile()) {
        box.on("mouseenter", this.onOver.bind(this, x))
        box.on("mouseleave", this.onOut.bind(this, x))
      }
      box.on("click", this.onClick.bind(this, x))

    }

    TweenMax.to(jQuery(".footer"), 0.5, { opacity: 1 });

  }
  getIdle(box) {
    return "idle" + Pqp.rnd(this["box" + box].idle - 1) + ".jpg";
  }
  getSmile(box) {
    return "smile" + Pqp.rnd(this["box" + box].smile - 1) + ".jpg";
  }
  getCry(box) {
    return "sad" + Pqp.rnd(this["box" + box].sad - 1) + ".jpg";
  }
  getLink(box) {
    return this["box" + box].url;
  }

  onOver(n) {
    let boxSmile = n;
    let boxCry;
    if (n === 0) {
      boxCry = 1;
    } else {
      boxCry = 0;
    }
    jQuery(".js-emote", jQuery(".js-box-" + boxSmile)).attr("src", this.getDir() + "box" + boxSmile + "/" + this.getSmile(boxSmile));
    jQuery(".js-emote", jQuery(".js-box-" + boxCry)).attr("src", this.getDir() + "box" + boxCry + "/" + this.getCry(boxCry));
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + boxSmile)), 0.3, { opacity: 1 });
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + boxCry)), 0.3, { opacity: 1 });
  }

  onOut(n) {
    //jQuery("img", jQuery(".js-box-" + 0)).attr("src", this.getDir() + "box" + 0 + "/" + this.getIdle(0));
    //jQuery("img", jQuery(".js-box-" + 1)).attr("src", this.getDir() + "box" + 1 + "/" + this.getIdle(1));
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + 0)), 0.3, { opacity: 0 });
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + 1)), 0.3, { opacity: 0 });
  }

  onClick(n) {
    window.location.href = this.getLink(n)

  }



}